import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import { useLang } from "../i18n/LanguageContext";
import { api, COMPANY } from "../lib/site";

export default function About() {
  const { t } = useLang();
  const points = ["about.point.1","about.point.2","about.point.3","about.point.4","about.point.5","about.point.6"];
  const { data: pageImagesSetting } = useQuery({ queryKey: ["settings","page_images"], queryFn: async () => { try { return (await api.get("/settings/page_images")).data; } catch { return null; } } });
  const pi = pageImagesSetting?.value || {};
  const aboutImg = pi.about_page_id ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${pi.about_page_id}` : (pi.about_page_url || "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1400&q=85&auto=format&fit=crop");
  return (
    <div className="min-h-screen">
      <Seo title={`${t("about.aboutTitle")} | ${COMPANY.name}`} description={t("section.about.desc")} path="/om-oss" />
      <Header />
      <section className="section">
        <div className="container-page grid gap-10 lg:grid-cols-12 items-start">
          <div className="lg:col-span-6">
            <span className="eyebrow">{t("section.about.eyebrow")}</span>
            <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">{t("section.about.title")}</h1>
            <div className="dot-divider mt-4" />
            <p className="mt-5 text-[#383E45] leading-relaxed">{t("section.about.desc")}</p>
            <p className="mt-4 text-[#383E45] leading-relaxed">{t("section.about.registered")}</p>
            <ul className="mt-6 space-y-2.5">
              {points.map((k) => <li key={k} className="flex gap-2.5"><CheckCircle2 className="text-[#1B3626] mt-0.5" size={18}/>{t(k)}</li>)}
            </ul>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link className="btn-primary" to="/be-om-pristilbud" data-testid="about-quote-btn">{t("cta.quote")}</Link>
              <Link className="btn-secondary" to="/prosjekter" data-testid="about-projects-btn">{t("cta.seeProjects")}</Link>
            </div>
          </div>
          <div className="lg:col-span-6">
            <img src={aboutImg} alt="Bygghåndverk" className="rounded-xl w-full h-[520px] object-cover" loading="lazy" />
          </div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
